/*
 * @Author: hongye
 * @Description:
 */
import { INTW_TIMES, INTW_SWITCH, BASE_ENV } from "@public/utils/const";
import { lang } from "./utils";
import store from "@/store";
import CryptoJS from "crypto-js"; // 加密 or 解密

const secretKey = BASE_ENV().secretKey;
export const AESUtil = {
  /**
   * AES加密方法
   * @param content 要加密的字符串
   * @returns {string} 加密结果
   */
  aesEncrypt: (content) => {
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const srcs = CryptoJS.enc.Utf8.parse(content);
    const encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encrypted.toString();
  },
  /**
   * 解密方法
   * @param encryptStr 密文
   * @returns {string} 明文
   */
  aesDecrypt: (encryptStr) => {
    const key = CryptoJS.enc.Utf8.parse(secretKey);
    const decrypt = CryptoJS.AES.decrypt(encryptStr, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  },
};

export const commonFun = {
  /**
   * @Title 是否为空判断
   * @Description TODO
   * @author xzd
   * @param val
   * @returns {Boolean} 空返回true
   */
  isEmpty(val) {
    if (typeof val === "string" || val instanceof String) {
      val = val.replace(/\s/g, "");
    }
    if (val === null) {
      return 1;
    }
    if (val === undefined || val === "undefined") {
      return 1;
    }
    if (val === "") {
      return 1;
    }
    if (val.length === 0) {
      return 1;
    }
    if (!/[^(^\s*)|(\s*$)]/.test(val)) {
      return 1;
    }
    return 0;
  },
  /**
   * @Title 判断obj对象是否没有属性
   * @Description 没有返回true
   * @param obj 只接收obj
   * @returns {boolean}
   */
  isEmptyProperty(obj) {
    let key;
    for (key in obj) {
      if (obj.hasOwnProperty(key)) {
        return 0; //  不为空返回false
      }
    }
    return 1; //  空返回true
  },
  /*
   * 获取数据字典
   * @author xzd
   * @param code
   */
  getDict(type, valType = "id") {
    // let dictList = cacheHelper.get('dict') || [];
    const { dict } = store.state.base;
    const LocaldictData = JSON.parse(localStorage.getItem("dict") || "[]");
    let dictList = dict || LocaldictData || [];
    const dictData = [];
    if (!dictList) {
      dictList = [];
      console.log("数据字典无数据");
    }
    dictList.forEach((item) => {
      if (item.code === type) {
        item.child.forEach((item2) => {
          dictData.push({
            value: +item2[valType],
            label: lang(item2.localName || item2.name),
            name: item2.localName || item2.name,
            code: item2.code,
            id: item2.id,
          });
        });
      }
    });
    return dictData;
  },
  /*
   * 获取当前时间
   * @author xzd
   * @param code
   */
  conver(s) {
    return s < 10 ? "0" + s : s;
  },
  getCurDate() {
    const myDate = new Date();

    // 获取当前年
    const year = myDate.getFullYear();

    // 获取当前月
    const month = myDate.getMonth() + 1;

    // 获取当前日
    const date = myDate.getDate();
    const h = myDate.getHours(); // 获取当前小时数(0-23)
    const m = myDate.getMinutes(); // 获取当前分钟数(0-59)
    const s = myDate.getSeconds();

    // 获取当前时间
    const day =
      year + "-" + commonFun.conver(month) + "-" + commonFun.conver(date);
    const hour =
      commonFun.conver(h) +
      ":" +
      commonFun.conver(m) +
      ":" +
      commonFun.conver(s);
    const now = day + " " + hour;
    return {
      dayHour: now,
      day,
      hour,
    };
  },

  // /* 获取当前月的第一天和最后一天 */
  // getCurrentMonth() {
  //   var date = new Date();
  //   var new_year = date .getFullYear();    //取当前的年份
  //   var month = date.getMonth();
  //   var new_month = month+1;//取当前的月份
  //   //alert("年："+ date .getFullYear()); //获取完整的年份(4位)
  //   //alert("月："+ new_month);
  //   if(month>12) {
  //       new_month -=12;        //月份减
  //       new_year++;            //年份增
  //   }
  //   var d = new Date(new_year,new_month,1);                //取当年当月中的第一天
  //   var lastDay = new Date(d.getTime()-1000*60*60*24).getDate();//获取当月最后一天日期
  //   if(d.getMonth() < 10){
  //       var mon = "0" + d.getMonth();
  //   }else{
  //       var mon = d.getMonth();
  //   }
  //   var cfmStartDate=d.getFullYear() + '-' + mon + '-' + "0"+d.getDate() + ' ' + "00" + ':' + "00" + ':' + "00";
  //   var cfmEndDate=d.getFullYear() + '-' + mon + '-' + lastDay + ' ' + 23 + ':' + 59 + ':' + 59;
  // },

  // // 获取当前月的开始时间和结束时间
  // getCurrentMonthFirst() {
  //   var date = new Date()
  //   date.setDate(1)
  //   var month = parseInt(date.getMonth() + 1)
  //   var day = date.getDate()
  //   if (month < 10) {
  //     month = '0' + month
  //   }
  //   if (day < 10) {
  //     day = '0' + day
  //   }
  //   return date.getFullYear() + '-' + month + '-' + day
  // },

  // getCurrentMonthLast() {
  //   var date = new Date()
  //   var currentMonth = date.getMonth()
  //   var nextMonth = ++currentMonth
  //   var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
  //   var oneDay = 1000 * 60 * 60 * 24
  //   var lastTime = new Date(nextMonthFirstDay - oneDay)
  //   var month = parseInt(lastTime.getMonth() + 1)
  //   var day = lastTime.getDate()
  //   if (month < 10) {
  //     month = '0' + month
  //   }
  //   if (day < 10) {
  //     day = '0' + day
  //   }
  //   return date.getFullYear() + '-' + month + '-' + day
  // },
  // 获取当天的开始与结束日期
  GetTodayDate(addDate = 0, addTime = true) {
    var dd = new Date();
    dd.setDate(dd.getDate() + addDate); // 获取第addDate天后的日期
    var y = dd.getFullYear();
    var m =
      dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; // 获取当前月份的日期，不足10补0
    var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); // 获取当前几号，不足10补0
    let start = y + "-" + m + "-" + d;
    addTime ? (start = start + " " + "00:00:00") : "";
    let end = y + "-" + m + "-" + d;
    addTime ? (end = end + " " + "23:59:59") : "";
    return [start, end];
  },
  // 获取当前年月份
  GetYearMonth(addDate = 0) {
    var dd = new Date();
    dd.setDate(dd.getDate() + addDate); // 获取第addDate天后的日期
    var y = dd.getFullYear();
    var m =
      dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1; // 获取当前月份的日期，不足10补0
    const start = y + "-" + m;
    const end = y + "-" + m;
    return [start, end];
  },
  // 获取当天日期的前7天日期
  getBeforeDate(n, type = "-") {
    const d = new Date();
    let year = d.getFullYear();
    let mon = d.getMonth() + 1;
    let day = d.getDate();
    if (day <= n) {
      if (mon > 1) {
        mon = mon - 1;
      } else {
        year = year - 1;
        mon = 12;
      }
    }
    d.setDate(d.getDate() - n);
    year = d.getFullYear();
    mon = d.getMonth() + 1;
    day = d.getDate();
    const s =
      year +
      type +
      (mon < 10 ? "0" + mon : mon) +
      type +
      (day < 10 ? "0" + day : day);
    return s;
  },
  // 16进制颜色转换
  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  },
  /**
   * 返回文件path
   * @param {*} value 需要截取的数字|字符串
   * @param {*} len 截取小数后的长度
   */
  getPaths(fileList = []) {
    const paths = fileList
      .map((file) => {
        if (file.path) {
          return file.path;
        }
        if (!file.downloadUrl) {
          return file;
        }
        // https://test-oss.jtexpress.com.cn/yljms/material/da01f095a0814958a37034f00dcea43d.jpg?Expires=1575294419&OSSAccessKeyId=LTAI4FvZVbX7F48wq3HJphaR&Signature=F1E5urdgnU3mKEgW44k9%2BCJA260%3D,https://test-oss.jtexpress.com.cn/yljms/material/2a8bc10e9f294c4eb5887161b9ff2c76.jpeg?Expires=1575294419&OSSAccessKeyId=LTAI4FvZVbX7F48wq3HJphaR&Signature=BaLMA7MAxX79XdnLtjm%2F0u0GPvg%3D"
        const urlList = file.downloadUrl.split(
          /.com.cn\/|.com\/|.cn\/|.net\/|\?/
        );
        file.path = urlList[1] || file;
        console.log("getPaths", file.path, file.downloadUrl);
        return file.path;
      })
      .join(",");
    return paths;
  },
  /**
   * @Title 各位转千位，万位等
   * @Description
   * @author hedongyang
   * @param 数量，四舍五入保留几位小数
   * @returns {数值，单位}:{ num: number, unit: string }
   */
  getNumberUnit(num, min = 10000, fixed = 0) {
    let numNum = 0;
    try {
      numNum = parseInt(num + "");
    } catch (error) {
      console.error(error);
      numNum = 0;
    }
    if (numNum >= min) {
      if (numNum >= 1000 && numNum < 10000) {
        numNum = parseInt((numNum / 1000).toFixed(fixed));
        return {
          num: numNum,
          unit: "千",
        };
      }
      if (numNum >= 10000 && numNum < 10000000) {
        numNum = parseInt((numNum / 10000).toFixed(fixed));
        return {
          num: numNum,
          unit: "万",
        };
      }
      // if (min >= 1000000 && 10000000 > numNum) {
      //     numNum = parseFloat((numNum / 1000000).toFixed(fixed));
      //     return {
      //         num: numNum,
      //         unit: '百万'
      //     };
      // }
      if (numNum >= 10000000 && numNum < 100000000) {
        numNum = parseInt((numNum / 10000000).toFixed(fixed));
        return {
          num: numNum,
          unit: "千万",
        };
      }
      if (numNum >= 100000000 && numNum < 10000000000) {
        numNum = parseInt((numNum / 100000000).toFixed(fixed));
        return {
          num: numNum,
          unit: "亿",
        };
      }
      if (numNum >= 10000000000) {
        numNum = parseInt((numNum / 10000000000).toFixed(fixed));
        return {
          num: numNum,
          unit: "百亿",
        };
      }
    }
    return {
      num: numNum,
      unit: "",
    };
  },
  /**
   * 为数字添加分隔符
   * eg:
   * input 1234567 return 12,345.67
   * @param nStr
   */
  formatNumber(nStr) {
    if (!nStr) {
      nStr = "0";
    }
    const x = (nStr + "").split(".");
    let x1 = x[0];
    const x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  },
};

/**
 * 接口定时延迟方法
 * @description:
 * @param { Funciton } fn 需要延迟执行的函数
 * @param { Number } delay 定时器间隔
 * @return { Number } 定时器的实例，用于取消定时器
 */
export const interfaceWaitHandle = (fn, delay = INTW_TIMES) => {
  if (INTW_SWITCH) {
    console.log("进入1秒延迟！");
    return setTimeout(fn, delay);
  } else {
    return fn();
  }
};
/*
 *@Description: 判断当前模块是否有对应的操作权限
 *@param {arg} moduleName type
 *@return [Boolean]
 *@Date: 2019-07-03 10:52:04
 */
export function hasPower(moduleName, type) {
  // let btnList = store.state.base.btnList || {};
  // let power = {};
  // if (btnList[moduleName]) {
  //   power = btnList[moduleName] || {};
  // } else {
  //   btnList = cacheHelper.get("btnList");
  //   if (btnList) power = btnList[moduleName] || {};
  // }
  // return power[type] || false;
  return true;
}
/**
 * 时间格式化
 * @param { String|Date } time 时间，可以是时间字符串，也可以是时间对象，如果传入为空，则默认使用当前时间
 * @param { String } formats 格式化类型 默认值YYYY-MM-DD
 * @return { String } 返回格式化后的时间字符串
 * 在vue实例里面可以如下使用 this.$common.formatDate('2019/9/11 11:22:44', 'YYYY-MM-DD HH:mm:ss')
 */
export const formatDate = (time, formats = "YYYY-MM-DD") => {
  // 转Date对象
  time = time ? new Date(time) : new Date();
  // 小于10添加0前缀
  const zero = (value) => (value < 10 ? "0" + value : value);
  // 年
  const year = time.getFullYear();
  // 月
  const month = zero(time.getMonth() + 1);
  // 日
  const day = zero(time.getDate());
  // 时
  const hours = zero(time.getHours());
  // 分
  const minutes = zero(time.getMinutes());
  // 秒
  const millisecon = zero(time.getSeconds());
  // map
  const timeMap = {
    YYYY: year,
    MM: month,
    DD: day,
    HH: hours,
    mm: minutes,
    ss: millisecon,
  };
  return formats.replace(/YYYY|MM|DD|HH|mm|ss/g, (matches) => timeMap[matches]);
};

const matchList = {
  '&#039;': '\'',
  '&#34;': '"',
  '&#60;': '<',
  '&#62;': '>',
  '&#38;': '&',
  '&#160;': ' '
}
// 字符过滤器
export const transferText = (text) => {
  if (!text) {
    return text
  }
  let regStr = '(' + Object.keys(matchList).toString() + ')'
  // ↑ ------------【*提取匹配列表key值*】.【组数转字符串】
  regStr = regStr.replace(/,/g, ')|(')
  // ↑ 通过匹配将其更新为正则的字符串类型
  const regExp = new RegExp(regStr, 'g')
  // ↑ ------- 字符串 转 正则 方法
  if (typeof text == 'string') {
    text = text.replace(regExp, match => matchList[match]) || text
  }
  return text
  // ↑ ------ 替换方法 (正则, 当前key => 返回当前被匹配的key值)
}
// 需要验签的接口
export const arr = [
  "/web/staff/login",
  "/web/staff/loginOut",
  "/web/staff/forgetPassword",
  "/web/staff/changePwd",
  "/web/smsRecord/sendSmsCaptcha",
  "/web/send-parcel/smartParse",
  "/web/send-parcel/totalCostMoney",
  "/web/send-parcel/saveOrder",
  "/web/send-parcel/orderList",
  "/web/send-parcel/sendParcelDetail",
  "/web/customerManager/queryCustomer",
  "/web/customerManager/addCustomer",
  "/web/customerManager/editCustomer",
  "/web/customerManager/delCustomer",
  "/web/send-parcel/printFaceSheet",
  "/web/online-pay/generateQrCode",
  "/web/online-pay/inquiryPaymentStatus",
  "/web/online-pay/paymentRecord",
  "/web/online-pay/polling",
  "/web/send-parcel/printReceipt",
  "/web/consumables/pageConsumablesVO",
  "/web/consumables/addConsumables",
  "/web/consumables/delConsumables",
  "/web/consumables/updateConsumables",
  "/web/customerManager/queryInfoByPhone",
  "/web/customerManager/checkRealName",
  "/web/customerManager/addRealName",
  "/web/customerManager/queryRealNameByMobile",
  "/web/customerManager/matchRecipient",
  "/web/send-parcel/batchAddSendParcel",
  "/web/send-parcel/addRecord"
];

// 排序的函数
export const objKeySort = (obj) => {
  const sortObj = {};
  let Objarr = {};
  var arrChild = []
  Object.keys(obj).sort().forEach(item => {
    if (obj[item] instanceof Array) {
      obj[item].forEach(index => {
        if (typeof index == 'object') {
          Object.keys(index).sort().forEach(indexKey => {
            Objarr[indexKey] = index[indexKey]
          })
          arrChild.push(Objarr)
          Objarr = {}// 每push一次把对象中的值清空一次
          obj[item] = arrChild;// 把排好序的重新赋值
        }
      })
    }
    sortObj[item] = obj[item];// 最外面对象排序赋值
  })
  return sortObj;
};

/* 删除数组属性为空 */
export function deleteNullKey(obj) {
  Object.keys(obj).forEach((item) => {
    if (obj[item] === null) {
      delete obj[item]
    } else if (toString.call(obj[item]) === '[object Array]') {
      obj[item].forEach((i, k) => {
        obj[item][k] = deleteNullKey(i)
      })
    } else if (toString.call(obj[item]) === '[object Object]') {
      obj[item] = deleteNullKey(obj[item])
    } else if (toString.call(obj[item]) === '[object Number]' && isNaN(obj[item])) {
      delete obj[item]
    }
  })
  return obj
}
// 手机号脱敏
export const mobileNumberChange = (str) => {
  return str.replace(/(\d{3})\d*(\d{4})/, "$1****$2");
};
// 姓名脱敏
export const formatName = (name) => {
  let newStr;
  if (name.length === 2) {
    newStr = name.substr(0, 1) + "*";
  } else if (name.length > 2) {
    let char = "";
    for (var i = 0, len = name.length - 2; i < len; i++) {
      char += "*";
    }
    newStr = name.substr(0, 1) + char + name.substr(-1, 1);
  } else {
    newStr = name;
  }
  return newStr;
};
